export default {
    en: {
        id: 'exercise6',
        subtitle: 'SUGGESTED STRUCTURE <br> PROPOSAL TO SPIRIT TELECOMS',
        blocks: [
            {
                task: `Need to build separate production unit to accommodate growth`,
                title: "S = ",
                answer: ' ',
                note: 'Sit, DE R1',
                disableEdit: true
            },
            {
                task: 'Want up and running in 6 months with minimum disruption to existing operations',
                title: "C = ",
                answer: ' ',
                note: 'Sol, R2',
                disableEdit: true
            },
            {
                task: '(Can you help us to do that?)',
                title: "Q = ",
                answer: ' ',
                disableEdit: true
            }
        ],
        image: '5d1-2.png',
        withoutAnswers: true,
        hideTaskTitle: true,
        submitButton: 'switch'
    },
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5c/practiceDefiningProblem2/i18n/exercise8.js